import { useMemo } from 'react'
import { useTranslation } from 'libs/i18n'
import { useDevice } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { getCardTableStyles } from 'styles/table'
import { OpeningHour } from 'features/openingHours/molecules/OpeningHour/OpeningHour'
import type { Option } from 'shared/components/ContextMenu/types'
import type { OpeningHourItem } from 'features/openingHours/types/openingHours.types'
import { useColumns } from '../hooks/useColumns'

type TableSectionProps = {
	results: OpeningHourItem[]
	total: number
	menuOptions: Option[]
}

export const TableSection = ({ results, total, menuOptions }: TableSectionProps) => {
	const { t } = useTranslation()
	const { isMobileOrTablet } = useDevice()
	const columns = useColumns({ menuOptions })
	const nodes = useMemo(
		() => results.map((openingHour) => ({ ...openingHour, id: openingHour.date })),
		[results]
	)

	return (
		<>
			{isMobileOrTablet ? (
				<ul className="divide-y divide-border">
					{results.map((openingHour) => (
						<OpeningHour
							key={openingHour.date}
							openingHour={openingHour}
							menuOptions={menuOptions}
						/>
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes }}
					isLoading={false}
					customStyles={getCardTableStyles(columns, { selectable: false, clickableRows: false })}
				/>
			)}
			<div className="border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground">
				{t('{{ count }} of {{ total }} entries', { count: results.length, total })}
			</div>
		</>
	)
}
